import { Add } from "@mui/icons-material";
import { Box, Button, Grid2, Paper, Stack, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import FormikTextField from "../../components/form/FormikTextField";
import { useNavigate } from "react-router";
import { deliverySlotsUrl } from "../../utils/urls";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../store/loaderSlice";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-hot-toast";
import PageHeader from "../../components/page-layout/PageHeader";

const AddDeliverySlot = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validationScheme = Yup.object({
    name: Yup.string().required("Delivery name is required"),
    start_time: Yup.string().required("Start time is required"),
    close_time: Yup.string().required("Close time is required"),
  });

  const initialValues = {
    name: "",
    start_time: "07:00",
    close_time: "21:00",
  };

  const onSubmit = (values) => {
    // Create an object with the keys that match your backend
    const submitData = {
      name: values.name,
      startTime: `${values.start_time}:00`, // Convert to full time format
      closeTime: `${values.close_time}:00`,
    };

    dispatch(showLoader("Adding New Delivery Slot..."));
    axiosInstance
      .post(deliverySlotsUrl, submitData)
      .then((data) => {
        toast.success(data.data.message);
        navigate(-1);
        dispatch(hideLoader());
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.error || "An error occurred");
        dispatch(hideLoader());
      });
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationScheme}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, values }) => (
          <>
            <PageHeader
              title="Add Delivery Slot"
              showBack={true}
              buttonTitle={"Add Delivery Slot"}
              buttonOnClick={handleSubmit}
            />

            {/* Visualize start and end time */}
            <Box display="flex" justifyContent="center" py={2}>
              <Paper elevation={2} sx={{ px: 4, py: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="subtitle1" color="text.secondary">
                  Open Time:
                </Typography>
                <Typography variant="h4" color="primary">
                  {values.start_time}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  —
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Close Time:
                </Typography>
                <Typography variant="h4" color="error">
                  {values.close_time}
                </Typography>
              </Paper>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 12 }}>
                  <FormikTextField name="name" label="Delivery Slot Name" />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <FormikTextField
                    name="start_time"
                    label="Open Time"
                    type="time"
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <FormikTextField
                    name="close_time"
                    label="Close Time"
                    type="time"
                  />
                </Grid2>
              </Grid2>
              </Box>
          </>
        )}
      </Formik>
    </Box>
  );
};

export default AddDeliverySlot;
